export function encode(str: string): string {
    return btoa(
        encodeURIComponent(str).replace(
            /%([0-9A-F]{2})/g,
            (match: string, p1: any) => String.fromCharCode(Number('0x' + (p1 as unknown as string)))
        )
    );
}